import React, { useEffect } from "react";
import PromoBar from "../components/PromoBar";
import EmotionPopup from "../components/EmotionPopup";
import ExitIntentPopup from "../components/ExitIntentPopup";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import VideoPresentation from "../components/VideoPresentation";
import SocialProof from "../components/SocialProof";
import About from "../components/About";
import HeroPackagesPreview from "../components/HeroPackagesPreview";
import HowItWorks from "../components/HowItWorks";
import CourseHighlight from "../components/CourseHighlight";
import OpportunitaHome from "../components/OpportunitaHome";
import LeadMagnetTrigger from "../components/LeadMagnetTrigger";
import Packages from "../components/Packages";
import Features from "../components/Features";
import Formazione from "../components/Formazione";
import Certifications from "../components/Certifications";
import Tesseramento from "../components/Tesseramento";
import Registro from "../components/Registro";
import Team from "../components/Team";
import PressEvents from "../components/PressEvents";
import BlogPreviewHome from "../components/BlogPreviewHome";
import TestimonianzaCameraHome from "../components/TestimonianzaCameraHome";
import Donate from "../components/Donate";
import HomeFAQ from "../components/HomeFAQ";
import CTASection from "../components/CTASection";
import Footer from "../components/Footer";
import StickyMobileCTA from "../components/StickyMobileCTA";
import SEO from "../components/SEO";
import useReveal from "../hooks/useReveal";

export default function Home() {
  useReveal();

  useEffect(() => {
    document.title = "A.C.D.T. – Associazione Consulenti e Consumatori Digitali";
  }, []);

  return (
    <div className="relative overflow-x-hidden">
      <SEO />
      <PromoBar />
      <Navbar />
      <Hero />
      <About />
      <TestimonianzaCameraHome />
      <VideoPresentation />
      <SocialProof />
      <HowItWorks />
      <CourseHighlight />
      <OpportunitaHome />
      <LeadMagnetTrigger />
      <HeroPackagesPreview />
      <Packages />
      <Features />
      <Formazione />
      <Certifications />
      <Tesseramento />
      <Registro />
      <Team />
      <PressEvents />
      <BlogPreviewHome />
      <Donate />
      <HomeFAQ />
      <CTASection />
      <Footer />
      <StickyMobileCTA />
      <EmotionPopup />
      <ExitIntentPopup />
    </div>
  );
}
